import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type FavState = {
  ids: string[];
  toggle: (dishId: string) => void;
  has: (dishId: string) => boolean;
  clear: () => void;
};

export const useFavorites = create<FavState>()(
  persist(
    (set, get) => ({
      ids: [],
      toggle: (dishId) => {
        const has = get().ids.includes(dishId);
        set({ ids: has ? get().ids.filter((x) => x !== dishId) : [...get().ids, dishId] });
      },
      has: (dishId) => get().ids.includes(dishId),
      clear: () => set({ ids: [] }),
    }),
    { name: 'resstro_menu_favorites' },
  ),
);
